export default {
  home: {
    realtime_trace: 'Real Time Track',
    history_trace: 'Historical Track',
    unit: 'Fixed Scene Monitoring',
    vehicle: 'Refrigerated Truck',
    new_ex: 'Latest Exception',
    carrier_normal_abnormal: 'Asset Status Normal/Abnormal',
    welcome: 'Welcome to Use',
    protect: 'Days of Cold Chain Safety Protection',
    recent_stat: 'Recent Statistics',
    probe_equi: 'Device Name',
    filter: 'Filter',
    no_range: 'No Detection Range',
    record_info: 'Record Infomation',
    range: 'Range',
    greater: 'geater than',
    less: 'less than',
    plan: 'Plan',
    please_enter_carrier: 'Please enter a sensor point name.',
    summary: 'Summary',
    carrier_status: 'Asset Status',
    handle_num: 'Handled Count',

    // 引导的标题
    home_ex: 'How to handle exceptions',
    history_data: 'How to view historical data',
    alarm_switch: 'How to enable/disable alarm function？',
    print_data: 'Print Data Guide',
    transport_code: 'How to view the transport code?',
    export_data: 'How to export data?',

    not_found_plan:'Please associate the floor plan first.',
    plan_map_home:'Floor Plan/Map Live',
    device_home:'Device Real-time Status',
    carrier_home:'Asset Real-time Status',
    open_org:'Unfold Organization',
    hide_org:'Fold Organization',
    show_org:'Organizational Nodes',
    handle_reason_required: 'Please select a handling reason',
    handle_person_required: 'Please enter the handler',
    handle_length_limit: 'Length must be within 30 characters',
    custom: 'Custom',

    // Dashboard related
    dashboard: {
      location_map: 'Location Map',
      dynamic_assets: 'Dynamic Assets',
      loading_assets: 'Loading assets...',
      no_assets_found: 'No assets found',
      view_details: 'View Details',
      device_ratio: 'Device ratio',
      abnormal_ratio: 'Abnormal Ratio',
      offline_ratio: 'Offline Ratio',
      device_status: 'Device Status',
      online: 'Online',
      abnormal: 'Abnormal',
      offline: 'Offline',
      recent_events: 'Recent Events',
      view_all: 'View All',
      environmental_trends: 'Environmental Trends',
      trend_range_7d: '7 days',
      trend_range_15d: '15 days',
      trend_range_30d: '30 days',
      export_data: 'Export Data',
      temperature_distribution: 'Temperature Distribution',
      humidity_distribution: 'Humidity Distribution',
      normal: 'Normal',
      loading_map: 'Loading map...',
      total_assets: 'Total Assets',
      static_assets: 'Static Assets',
      dynamic_assets_label: 'Dynamic Assets',
      total_alarms: 'Total Alarms',
      device_offline: 'Device Offline',
      device_power_outage: 'Device Power Outage',
      temperature_alert: 'Temperature Alert',
      humidity_alert: 'Humidity Alert',
      lost_connection: 'lost connection',
      exceeded_threshold: 'exceeded threshold',
      power_outage: 'power outage',
      no_description: 'No description',
      just_now: 'Just now',
      min_ago: 'min ago',
      hour_ago: 'hour ago',
      day_ago: 'day ago',
      unknown: 'Unknown',
      organization: 'Organization',
      dashboard: 'Dashboard',
      real_time_monitoring: 'Real-time Monitoring',
      customer_no_location_title: 'Notice',
      customer_no_location_message: 'Current customer has no location, will try to get your current location',
      current_location: 'Current Location',
      default_location: 'Default Location',
      view_history_trace: 'View History Trace',
      online_devices: 'Online Devices',
      warning_devices: 'Warning Devices',
      danger_devices: 'Danger Devices',
      vehicles: 'Vehicles',
      no_recent_alerts: 'No recent alerts',
      unknown_carrier: 'Unknown carrier',
      s_ago: 's ago',
      m_ago: 'min ago',
      h_ago: 'h ago',
      d_ago: 'd ago'
    }
  }
}
